import { RFP_PAYMENT_OPTION_TEN_PERCENT, RFP_PAYMENT_OPTIONS, RFP_TYPE_PUBLIC_OFFERING, RFP_TYPE_DIRECT_OFFER, RFP_VIEW_REQUEST_STATUS_APPROVAL, RFP_VIEW_REQUEST_PROPOSAL_UNREGISTERED, RFP_VIEW_REQUEST_PROPOSAL_REFUSE, RFP_VIEW_REQUEST_PROPOSAL_TO_DO, RFP_ROLE_ADMINISTRATOR, RFP_ROLES, RFP_INVOLVEMENTS, RFP_OFFER_MEMBER_TYPE_COMPANY, RFP_OFFER_MEMBER_TYPE_OUTSIDE, } from '../define/consts/rfp';
import { findCandidatesLabel } from './common';
/**
 * 役割のテキスト表示
 * @deprecated TS化で未使用になるため削除予定
 * @param role
 * @returns {*|string|string}
 */
export const getRoleText = (role) => {
    const value = parseInt(role, 10);
    return (RFP_ROLES.find((v) => v.value === value) || {}).label;
};
/**
 * 関わり方のテキスト表示
 * @deprecated TS化で未使用になるため削除予定
 * @param involvement
 * @returns {*|string|string}
 */
export const getInvolvementText = (involvement) => (RFP_INVOLVEMENTS.find((v) => v.value === involvement) || {}).label;
/**
 * 支払い方法のテキスト表示（複数）
 * @deprecated TS化済 src/utils/resources/rfp/rfpOfferPaymentOption.ts
 * @param rfp
 * @param hasAnnotation
 * @param hasNewLine
 * @returns {string|*}
 */
export const getPaymentOptionsText = (rfp = {}, hasAnnotation = false, hasNewLine = false) => {
    const { budget, max_budget: maxBudget, payment_option: paymentOption } = rfp;
    const newLine = hasNewLine ? '\n' : '';
    const joinText = `${newLine}または`;
    // 注釈なし
    if (!hasAnnotation) {
        return paymentOption
            .map((v) => findCandidatesLabel(RFP_PAYMENT_OPTIONS, v))
            .filter((v) => v)
            .join(joinText);
    }
    // 成果報酬のみの場合
    const isOnlyAchievementReward = paymentOption.length === 1 &&
        paymentOption[0] === RFP_PAYMENT_OPTION_TEN_PERCENT.value;
    if (isOnlyAchievementReward) {
        return RFP_PAYMENT_OPTION_TEN_PERCENT.label;
    }
    const hasAchievementReward = paymentOption.some((v) => v === RFP_PAYMENT_OPTION_TEN_PERCENT.value);
    const options = paymentOption.filter((v) => v !== RFP_PAYMENT_OPTION_TEN_PERCENT.value);
    const labels = options
        .map((v) => findCandidatesLabel(RFP_PAYMENT_OPTIONS, v))
        .filter((v) => v)
        .join(joinText);
    const annotation = `（${!budget && !maxBudget ? 'ご提案金額' : '予算上限額'}に対してのご請求）`;
    const text = `${labels}${newLine}${annotation}`;
    return hasAchievementReward
        ? `${text}${joinText}${RFP_PAYMENT_OPTION_TEN_PERCENT.label}`
        : text;
};
/**
 * 面接予定日のテキストを改行区切りで配列にして返す
 * @param interviewSchedule
 * @returns {*|array}
 */
export const splitInterviewSchedule = (interviewSchedule) => {
    if (!interviewSchedule) {
        return [];
    }
    return interviewSchedule
        .split('\n')
        .map((v) => v.trim())
        .filter((v) => v);
};
/**
 * 提案の面談希望日のテキストを画面表示用に整形して返す
 * @param value
 * @returns {string}
 */
export const offerCandidateInterviewDateForView = (value) => (value || '')
    .split('\n')
    .map((v) => v.trim())
    .filter((v) => v.length)
    .join('、') || '-';
/**
 * 公募案件か
 * @param rfpType
 * @returns {boolean}
 */
export const isRfpTypePublicOffer = (rfpType) => rfpType === RFP_TYPE_PUBLIC_OFFERING.value;
/**
 * 直接案件か
 * @param rfpType
 * @returns {boolean}
 */
export const isRfpTypeDirectOffer = (rfpType) => rfpType === RFP_TYPE_DIRECT_OFFER.value;
/**
 * 直接/公募提案のフォーム名を取得
 * @param id
 * @param rfpType
 * @returns {string}
 */
export const getRfpOfferFormName = (id, rfpType) => {
    let formName = '';
    if (isRfpTypeDirectOffer(rfpType)) {
        formName = 'RfpOfferDirectForm';
    }
    if (isRfpTypePublicOffer(rfpType)) {
        formName = 'RfpOfferPublicForm';
    }
    return `${formName}_${id}`;
};
/**
 * 閲覧承認済みか
 * @param viewRequestStatus
 * @returns {boolean}
 */
export const isViewRequestStatusApproved = (viewRequestStatus) => viewRequestStatus === RFP_VIEW_REQUEST_STATUS_APPROVAL.value;
/**
 * 提案検討中か
 * @param proposal
 * @returns {boolean}
 */
export const isProposalUnregistered = (proposal) => proposal === RFP_VIEW_REQUEST_PROPOSAL_UNREGISTERED.value;
/**
 * 提案予定か
 * @param proposal
 * @returns {boolean}
 */
export const isProposalTodo = (proposal) => proposal === RFP_VIEW_REQUEST_PROPOSAL_TO_DO.value;
/**
 * 辞退済みか
 * @param proposal
 * @returns {boolean}
 */
export const isProposalRefuse = (proposal) => proposal === RFP_VIEW_REQUEST_PROPOSAL_REFUSE.value;
/**
 * 社内メンバーか
 * @deprecated TS化済 src/utils/resources/rfp/rfpOfferMember.ts
 * @param memberType
 * @returns {boolean}
 */
export const isRfpOfferMemberTypeCompany = (memberType) => memberType === RFP_OFFER_MEMBER_TYPE_COMPANY.value;
/**
 * 社外メンバーか
 * @deprecated TS化済 src/utils/resources/rfp/rfpOfferMember.ts
 * @param memberType
 * @returns {boolean}
 */
export const isRfpOfferMemberTypeOutside = (memberType) => memberType === RFP_OFFER_MEMBER_TYPE_OUTSIDE.value;
/**
 * roleが管理者かどうか
 * @deprecated src/utils/resources/rfp/rfpRoles.ts
 * @param role
 * @returns {boolean}
 */
export const isRoleAdministrator = (role) => role === RFP_ROLE_ADMINISTRATOR.value;
